import parsePhoneNumber from 'libphonenumber-js'
import {mapActions, mapState} from 'vuex'
import * as types from '@/store/types'
import Helper from '@/utils/helper'
import CookieHelper from '@/utils/cookie-helper'

const mask = '+7'

export default {
    data() {
        return {
            form: {
                name: '',
                phone: `${mask}`,
                email: ''
            }
        }
    },
    computed: {
        ...mapState({
            queue: state => state.app.queue,
            client: state => state.app.client,
            servicing: state => state.app.servicing
        }),
        isValidForm() {
            let phoneNumber

            try {
                phoneNumber = parsePhoneNumber(this.form.phone, 'RU')
                if (phoneNumber) {
                    return phoneNumber.isValid()
                } else {
                    return false
                }
            } catch (e) {
                return false
            }
        }
    },
    methods: {
        ...mapActions({
            appMenuItemsSet: types.APP.menuItems.set,
            appClientSet: types.APP.client.set
        }),
        onChange() {
            this.form.phone = this.form.phone.replace(/ /gi, '')
            if (this.form.phone.substring(0, 2) !== '+7' && this.form.phone.length < 2) {
                this.form.phone = '+7'
            }
            this.form.phone = this.form.phone.substring(0, 12)
        },
        create() {
            this.$service._setGuiLoading()
            this.$service.create(this.queue, this.form.phone).then((data) => {
                CookieHelper.setClientId(this.$cookie, data.getId())
                this.appClientSet(data)
            }).finally(() => {
                this.$pageManager.showClient()
                this.$service._unsetGuiLoading()
            })
        },
        back() {
            this.$service._setGuiLoading()
            this.$service.getMenu().then((data) => {
                this.appMenuItemsSet(data.getItems())
            }).finally(() => {
                this.$service._unsetGuiLoading()
                this.$pageManager.showHome()
            })
        }
    },
    beforeMount() {
        if (!Helper.isDefined(this.queue)) {
            this.$service._setGuiLoading()
            this.$pageManager.showInit()
            this.$service._unsetGuiLoading()
        }

        if (Helper.isDefined(this.servicing)) {
            this.$service._setGuiLoading()
            this.$pageManager.showServicing()
            this.$service._unsetGuiLoading()
        }

        if (Helper.isDefined(this.client)) {
            this.$service._setGuiLoading()
            this.$pageManager.showClient()
            this.$service._unsetGuiLoading()
        }
    }
}
